import { tw } from "@careinfo/tailwind";
import React from "react";

const Skeleton = () => {
  return (
    <div
      className={tw`w-full bg-white p-4 rounded-md mb-8  `}
      style={{ boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)" }}
    >
      <div className={tw`w-full h-8 bg-gray-200 animate-pulse mt-10`}></div>
      <div className={tw`grid grid-cols-3 gap-x-2 gap-y-10 mt-10`}>
        {Array.from({ length: 9 }).map((__, index) => {
          return (
            <div className={tw`my-6`} key={index}>
              <div
                className={tw`py-10 bg-gray-200 animate-pulse shadow-md p-8`}
              ></div>
            </div>
          );
        })}
      </div>
      <div className={tw` flex justify-end w-full`}>
        <div className={tw`w-32 h-10 bg-gray-200 rounded-lg`}></div>
      </div>
    </div>
  );
};

export default Skeleton;
